import axios from "axios";

const getPublicQRScan = async (code) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}qr-scan/public/?code=${encodeURIComponent(code)}`,
    );

    return res;
  } catch (error) {
    console.error("Public QR scan fetch error:", error);
    throw error;
  }
};

export { getPublicQRScan };
